module.exports = __webpack_public_path__ + "static/media/updateContactLarge.135c57ae.svg";